import React from 'react';
import { AsyncSelectField, DateField, TimeField } from "../../../../Utils/renderField/fieldsHookForms";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { Link } from 'react-router-dom';
import Contenedor from './Contenedor';
import moment from 'moment';
import { CrearRecepcionesApi } from '../Api/CrearRecepcionesApi';
import { formToPayload } from '../Utils/data';
import { NotificationManager } from "react-notifications";
import LoadMask from '../../../../Utils/LoadMask/LoadMask';
import { InitForm } from '../Utils/InitForm';
import "react-datepicker/dist/react-datepicker.css";


/**
 * Componente para crear recepciones con contenedores.
 * @param {*} props propiedades del componente
 * @param {function} props.VerDetalleContenedores función para redirigir a la vista de detalle de contenedores.
 * @returns {JSX.Element} Componente de creación de recepciones con contenedores.
 */
const CrearRecepciones = (props) => {
    const { VerDetalleContenedores, pesoManual = true } = props;

    // __________ API __________
    const {
        vehiculosDefault,
        pilotosDefault,

        fincasDefault,
        tiposMateriaPrima,
        productosLatex,
        productosSolidos,

        cargandoInicio,
    } = InitForm();

    const {
        getVehiculos,
        getPilotos,
        guardarRecepciones,
        cargandoGuardado,
    } = CrearRecepcionesApi();


    // __________ FORM __________
    const methods = useForm({
        defaultValues: {
            fecha: moment(),
            hora_ingreso: moment().format('HH:mm'),
            contenedores: [{
                finca: null,
                tipo_materia_prima: null,
                peso_bruto_ingreso: null,
                productos: [{}],
            }],
        },
        mode: "onTouched",
    });

    const { control, formState: { errors }, watch, reset, trigger } = methods;

    const { fields, append, remove } = useFieldArray({
        control,
        name: "contenedores",
    });

    // __________ FUNCIONALIDAD __________
    const agregarContenedor = () => {
        if (fields.length >= 3) {
            NotificationManager.info('No se pueden agregar más de 3 contenedores', 'INFORMACIÓN', 3000);
            return;
        };

        append({
            productos: [{}],
        }, {
            shouldFocus: false,
        });
    }

    const GuardarRecepciones = async () => {
        const isValid = await trigger();
        if (!isValid) return;

        const formData = methods.getValues();

        const payload = formToPayload(formData);

        const response = await guardarRecepciones(payload);

        if (!response) {
            NotificationManager.error('Ocurrió un error', 'ERROR', 3000);
        };
        if (response) {
            NotificationManager.success('Recepciones creadas', 'Éxito', 3000);
            // redirigir a detalle de recepciones creadas
            VerDetalleContenedores(response.viaje_id);
        }
    }

    return (
        <FormProvider {...methods}>
            <LoadMask loading={cargandoInicio || cargandoGuardado} blur>
                <div className="crear-recepciones__form">
                    {/* DATOS GENERALES */}
                    <div className="crear-recepciones__general-fields">
                        <div className="formulario-fields-row mt-0">
                            <div className="formulario-field">
                                <label htmlFor="fecha">FECHA</label>
                                <DateField
                                    control={control}
                                    name="fecha"
                                    errors={errors}
                                    rules={{
                                        required: "Este campo es obligatorio",
                                    }}
                                />
                            </div>
                            <div className="formulario-field">
                                <label htmlFor="hora_ingreso">HORA</label>
                                <TimeField
                                    control={control}
                                    name="hora_ingreso"
                                    errors={errors}
                                    rules={{
                                        required: "Este campo es obligatorio",
                                    }}
                                />
                            </div>
                            <div className="formulario-field">
                                <label htmlFor="vehiculo">VEHÍCULO</label>
                                <AsyncSelectField
                                    control={control}
                                    name="vehiculo"
                                    errors={errors}
                                    rules={{
                                        required: "Este campo es obligatorio",
                                    }}
                                    loadOptions={getVehiculos}
                                    defaultOptions={vehiculosDefault}
                                    cacheOptions
                                />
                            </div>
                            <div className="formulario-field">
                                <label htmlFor="piloto">PILOTO</label>
                                <AsyncSelectField
                                    control={control}
                                    name="piloto"
                                    errors={errors}
                                    rules={{
                                        required: "Este campo es obligatorio",
                                    }}
                                    loadOptions={getPilotos}
                                    defaultOptions={pilotosDefault}
                                    cacheOptions
                                />
                            </div>
                        </div>
                    </div>

                    {/* CONTENEDORES */}
                    <div className="crear-recepciones__contenedores mt-1">
                        {fields.map((contenedor, index) => (
                            <Contenedor
                                key={contenedor.id}
                                index={index}
                                disableRemove={fields.length === 1}
                                quitarContenedor={() => remove(index)}
                                fincasDefault={fincasDefault}
                                tiposMateriaPrima={tiposMateriaPrima}
                                productosLatex={productosLatex}
                                productosSolidos={productosSolidos}
                                pesoManual={pesoManual}
                            />
                        ))}
                    </div>

                    {/* BOTÓN PARA AGREGAR CONTENEDORES */}
                    <button className="btn btn-secondary mt-3" onClick={agregarContenedor}>AGREGAR CONTENEDOR</button>

                    {/* BOTONES DE ACCIÓN */}
                    <div className="formulario-actions">
                        <Link className="btn btn-outline-dark" to="/ingresos">CANCELAR</Link>
                        <button className="btn btn-primary" onClick={GuardarRecepciones}>GUARDAR RECEPCIONES</button>
                    </div>
                </div>
            </LoadMask>
        </FormProvider>
    )
}

export default CrearRecepciones
